
/**
 * 주문 타입
 */
export type GetOrders200OrdersItemOrderType = typeof GetOrders200OrdersItemOrderType[keyof typeof GetOrders200OrdersItemOrderType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOrders200OrdersItemOrderType = {
  SUBSCRIPTION: 'SUBSCRIPTION',
  ONE_TIME: 'ONE_TIME',
} as const;
